import "./CompanyLayout.css";

import {
  NavLink,
  Outlet,
  useParams,
} from "react-router-dom";

import { usePermissions } from "./PermissionContext";
import { useCompanyBranding } from "./CompanyBrandingContext";

function CompanyLayout() {
  const { company } = useParams();

  const {
    can,
    loadingPermissions,
  } = usePermissions();

  const {
    branding,
    companyName,
  } = useCompanyBranding();

  const menuItems = [
    {
      label: "Dashboard",
      path: "dashboard",
      permission: "dashboard.view",
    },
    {
      label: "Usuarios",
      path: "usuarios",
      permission: "users.view",
    },
    {
      label: "Clientes",
      path: "clientes",
      permission: "customers.view",
    },
    {
      label: "Productos",
      path: "productos",
      permission: "products.view",
    },
    {
      label: "Listas de precios",
      path: "listas-precios",
      permission: "products.view",
    },
    {
      label: "Promociones",
      path: "promociones",
      permission: "products.view",
    },
    {
      label: "Compras",
      path: "compras",
      permission: "purchases.view",
    },
    {
      label: "Órdenes de compra",
      path: "ordenes-compra",
      permission: "purchases.view",
    },
    {
      label: "Caja",
      path: "caja",
      permission: "cash.view",
    },
    {
      label: "Cierres de caja",
      path: "cierres-caja",
      permission: "cash.view",
    },
    {
      label: "Ventas",
      path: "ventas",
      permission: "sales.view",
    },
    {
      label: "Inventario",
      path: "inventario",
      permission: "inventory.view",
    },
    {
      label: "Bodegas",
      path: "bodegas",
      permission: "inventory.view",
    },
    {
      label: "Transferencias de bodega",
      path: "transferencias-bodega",
      permission: "inventory.view",
    },
    {
      label: "Conteos físicos",
      path: "conteos-fisicos",
      permission: "inventory.view",
    },
    {
      label: "Facturación",
      path: "facturacion",
      permission: "billing.view",
    },
    {
      label: "Reportes",
      path: "reportes",
      permission: "reports.view",
    },
    {
      label: "Proveedores",
      path: "proveedores",
      permission: "suppliers.view",
    },
    {
      label: "Contabilidad",
      path: "contabilidad",
      permission: "accounting.view",
    },
    {
      label: "Bancos",
      path: "bancos",
      permission: "banks.view",
    },
    {
      label: "Configuración",
      path: "configuracion",
      permission: "settings.view",
    },
  ];

  const logout = () => {
    localStorage.removeItem("company_token");
    localStorage.removeItem("company_info");

    window.location.href = `/${company}`;
  };

  return (
    <div className="company-layout">
      <aside className="company-sidebar">
        <div className="company-sidebar-brand">
          {branding.logo && (
            <img
              src={
                branding.logo.startsWith("http")
                  ? branding.logo
                  : `/api${branding.logo}`
              }
              alt={`Logo de ${companyName}`}
            />
          )}

          <h2>{companyName}</h2>
        </div>

        <nav>
          {loadingPermissions ? (
            <span className="company-menu-loading">
              Cargando menú...
            </span>
          ) : (
            menuItems
              .filter((item) => can(item.permission))
              .map((item) => (
                <NavLink
                  key={item.path}
                  to={`/${company}/${item.path}`}
                  className={({ isActive }) =>
                    isActive ? "active" : ""
                  }
                >
                  {item.label}
                </NavLink>
              ))
          )}
        </nav>

        <button
          type="button"
          className="logout-btn"
          onClick={logout}
        >
          Cerrar sesión
        </button>
      </aside>

      <div className="company-main">
        <header className="company-header">
          <h3>{companyName}</h3>

          <span>
            {branding.role || "Usuario"}
          </span>
        </header>

        <main className="company-content">
          <Outlet />
        </main>

        <footer className="company-footer">
          © {new Date().getFullYear()} NetLedger
        </footer>
      </div>
    </div>
  );
}

export default CompanyLayout;